module.exports = __webpack_public_path__ + "media/images/signout-b2a812897ba4b97fac5258639c535899.png";